// Motivo legible de un asiento de tarjetas PCF, el mismo en la pantalla Tarjetas y en Inventario.
import type { CardStockMovementResponse } from '@fiado/type-kit/bin/retailCards/dtos/responses/CardStockMovementResponse';
import { CARD_WRITE_OFF_REASONS } from './constants';

const NO_REASON = '—';

/** Motivo de la baja o de la reversa; la reversa a veces trae el motivo catalogado y no texto libre. */
export function cardMovementReason(
    movement: Pick<CardStockMovementResponse, 'reason' | 'reversalReason'>,
): string {
    if (movement.reason) return CARD_WRITE_OFF_REASONS[movement.reason] ?? movement.reason;
    if (movement.reversalReason) {
        return CARD_WRITE_OFF_REASONS[movement.reversalReason] ?? movement.reversalReason;
    }
    return NO_REASON;
}
